import * as React from 'react';
import { DomUid } from '../libs/dom-uid';

declare const $: any;

export class ToggleBoxComponent extends React.Component<{
    closed?: boolean,
    color?: string,
    title: any,
    alwaysOpen?: boolean,
    preIcon?: string,
    defaultClosed?: boolean,
}> {

    public uid = DomUid();

    public state: any = {
        closed: this.props.closed
    };

    public toggleComponent(): void {
        this.setState({
            closed: !this.state.closed
        });
        $(`#${this.uid}`).find('.content-box-wrapper').slideToggle();
    }

    componentDidMount() {
        if (this.props.defaultClosed) {
            this.toggleComponent();
        }
    }

    render() {
        return (
            // tslint:disable-next-line
            <div className={'content-box border-top ' + (this.props.color ? `border-${this.props.color}` : 'border-blue')} id={this.uid}>
                <h3 className="content-box-header bg-default">
                    {this.props.preIcon && <span className="icon-separator">
                        <i className={'fa ' + this.props.preIcon} />
                    </span>}
                    {this.props.title}
                    {!this.props.alwaysOpen &&
                    <div className="header-buttons-separator">
                        <a onClick={() => this.toggleComponent()} className="icon-separator toggle-button">
                            {this.state.closed && <i className="glyph-icon fa-chevron-down"/>}
                            {!this.state.closed && <i className="glyph-icon fa-chevron-down icon-rotate-180"/>}
                        </a>
                    </div>
                    }
                </h3>
                <div className="content-box-wrapper pad10T">
                    {/*<div className="row">*/}
                        {this.props.children}
                    {/*</div>*/}
                </div>
            </div>
        );
    }
}

// @TODO -> Le lehessen tiltani a nyitas/zaras funkciot



// WEBPACK FOOTER //
// ./src/components/structurals/toggle-box.component.tsx